import { render, staticRenderFns } from "./AdminCartWidget.vue?vue&type=template&id=5422c051&scoped=true"
import script from "./AdminCartWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCartWidget.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminCartWidget.vue?vue&type=style&index=0&id=5422c051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422c051",
  null
  
)

export default component.exports